import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function geturlForUploadOrderDocument({ params }) {
  const apiPath = '/uploadUrl'
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  const httpClient = new HttpClient(headers)

  return httpClient.documentInstance().get(apiPath, {
    params: {
      documentType: params.documentType,
      orderId: params.orderId,
      file: params.file,
      contentType: params.contentType,
    },
  })
}
